<template>
   <v-container fluid>
      <v-row>
         <v-col cols="12" md="12">
            <v-toolbar dense color="primary white--text" bottom>
               <v-toolbar-title v-if="$vuetify.breakpoint.mdAndUp">
                  Manage CCA Proposal
               </v-toolbar-title>
               <v-icon color="white" v-else>mdi-playlist-check</v-icon>
            </v-toolbar>
         </v-col>
         <v-row dense class="ml-md-10 ml-sm-2 px-sm-2">
            <v-col cols="12" md="3">
               <keep-alive>
                  <v-select
                     class="ml-5"
                     label="Select Primary/Secondary"
                     :items="yeargroupselect"
                     v-model="selectedyeargroup"
                     return-object
                     @change="changeYearGroup"
                  >
                  </v-select>
               </keep-alive>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="12" md="3">
               <v-select
                  class="ml-5"
                  label="Proposal Status"
                  :items="proposalstatus_select"
                  v-model="selectedproposalstatus"
                  return-object
                  @change="updateSelectedProposalStatus"
               ></v-select>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="12" md="3">
               <v-checkbox
                  class="pt-3"
                  label="Inc. Assisting Teacher"
                  v-model="include_assisting"
                  @change="reloadProposal"
               ></v-checkbox>
            </v-col>
         </v-row>
      </v-row>
      <v-row justify="space-around" class="pt-2">
         <v-col cols="12" md="11">
            <v-card>
               <v-data-table
                  dense
                  :items="proposaldata"
                  :headers="proposalheaders"
                  item-key="id"
                  single-select
                  :options.sync="pagination"
                  :items-per-page="propItemsPerPage"
                  @update:items-per-page="itemPerPageChange"
                  @click:row="proposalRowClick"
               >
                  <!-- eslint-disable-next-line -->
                  <template v-slot:item.actions="{item}">
                     <v-icon
                        v-if="item.proposer_role == CCA_ROLE.LEAD_TEACHER"
                        small
                        @click="editProposal(item)"
                     >
                        mdi-pencil
                     </v-icon>
                     <v-icon class="ml-2" small @click="deleteProposal(item)">mdi-delete</v-icon>
                  </template>
               </v-data-table>
            </v-card>
         </v-col>
      </v-row>
      <confirm-dlg ref="confirm"></confirm-dlg>
   </v-container>
</template>

<script>
   import ConfirmDlg from "../components/ConfirmDlg.vue";
   export default {
      components: {ConfirmDlg},

      inject: ["ShowMessage"],

      data() {
         return {
            CCA_ROLE: {
               LEAD_TEACHER: "1",
               ASSISTING_TEACHER: "2",
            },
            PROPOSALSTATUS: {
               PENDING: 0,
               APPROVED: 1,
               REJECTED: 2,
               KIV: 3,
            },
            proposalstatus_select: [
               {id: -1, text: "All"},
               {id: 0, text: "Pending"},
               {id: 1, text: "Approved"},
               {id: 2, text: "Rejected"},
               {id: 3, text: "KIV"},
            ],
            selectedproposalstatus: null,
            propItemsPerPage: this.$globalstore.proposal.itemsperpage || 10,
            pagination: {},
            proposaldata: [],
            selectedyeargroup: null,
            include_assisting: true,
            yeargroupselect: [
               {id: 1, text: "Primary", yeargroup: [1, 2, 3, 4, 5, 6]},
               {
                  id: 2,
                  text: "Secondary",
                  yeargroup: [7, 8, 9, 10, 11, 12, 13],
               },
            ],

            proposal_header: [
               {
                  text: "Year/Term",
                  value: "yeartermtext",
                  width: "12%",
                  class: this.$globalstore.table_headerclass,
               },
               {
                  text: "Proposer",
                  value: "proposername",
                  width: "15%",
                  class: this.$globalstore.table_headerclass,
               },
               {
                  text: "Name",
                  value: "cca_name",
                  width: "25%",
                  class: this.$globalstore.table_headerclass,
               },
               {
                  text: "Role",
                  value: "roletext",
                  width: "10%",
                  class: this.$globalstore.table_headerclass,
               },
               {
                  text: "Year",
                  value: "yeargrouptext",
                  width: "10%",
                  class: this.$globalstore.table_headerclass,
               },
               {
                  text: "Status",
                  value: "adminstatustext",
                  width: "12%",
                  class: this.$globalstore.table_headerclass,
               },
               {
                  text: "",
                  value: "actions",
                  width: "15%",
                  align: "end",
                  class: this.$globalstore.table_headerclass,
               },
            ],
         };
      },

      computed: {
         proposalheaders() {
            return [
               {
                  text: "",
                  value: "admin_status",
                  width: "0%",
                  align: " d-none",
                  filter: (value) => {
                     if (!this.selectedproposalstatus || this.selectedproposalstatus.id === -1)
                        return true;
                     else {
                        return value == this.selectedproposalstatus.id;
                     }
                  },
               },
               {
                  text: "Year/Term",
                  value: "yeartermtext",
                  width: "15%",
                  class: this.$globalstore.table_headerclass,
               },
               {
                  text: "Proposer",
                  value: "proposername",
                  width: "20%",
                  class: this.$globalstore.table_headerclass,
               },
               {
                  text: "Name",
                  value: "cca_name",
                  width: "25%",
                  class: this.$globalstore.table_headerclass,
               },
               {
                  text: "Role",
                  value: "roletext",
                  width: "10%",
                  class: this.$globalstore.table_headerclass,
               },
               {
                  text: "Year",
                  value: "yeargrouptext",
                  width: "10%",
                  class: this.$globalstore.table_headerclass,
               },
               {
                  text: "Status",
                  value: "adminstatustext",
                  width: "12%",
                  class: this.$globalstore.table_headerclass,
               },
               {
                  text: "",
                  value: "actions",
                  width: "12%",
                  align: "end",
                  class: this.$globalstore.table_headerclass,
               },
            ];
         },
      },

      methods: {
         updateSelectedProposalStatus() {
            this.$globalstore.proposal.selectedproposalstatus = Object.assign(
               {},
               this.selectedproposalstatus
            );
         },

         itemPerPageChange(count) {
            this.$globalstore.proposal.itemsperpage = count;
         },

         changeYearGroup() {
            // This is called when Primary/Secondary is selected
            if (this.selectedyeargroup) {
               this.$globalstore.proposal.yeargroup = Object.assign({}, this.selectedyeargroup);
               this.loadProposal();
            }
         },

         reloadProposal() {
            // This is called when assisting teacher checkbox is checked.
            if (this.selectedyeargroup) {
               this.loadProposal();
            }
         },

         proposalRowClick(item, row) {
            row.select(!row.isSelected);
         },

         editProposal(item) {
            this.$globalstore.proposal.proposaldata = this.proposaldata.slice();
            this.$globalstore.proposal.page = this.pagination.page;

            this.$router.push({
               name: "EditProposal",
               params: {proposalid: item.id},
            });
         },

         deleteProposal(item) {
            if (
               item.admin_status == this.PROPOSALSTATUS.PENDING ||
               item.admin_status == this.PROPOSALSTATUS.KIV
            ) {
               var msg;
               if (item.proposer_role == this.CCA_ROLE.LEAD_TEACHER) {
                  msg =
                     "Are you sure you want to remove this proposal? " +
                     "This will also remove any linked assisting teacher's proposal.";
               } else {
                  msg = "Are you sure you want to remove this proposal?";
               }

               this.$refs.confirm.open("Warning", msg, {color: "orange"}).then((reply) => {
                  if (reply) {
                     this.doDeleteProposal(item);
                  }
               });
            } else {
               this.ShowMessage({
                  title: "Error",
                  message: "You may only remove pending or KIV proposals.",
                  color: "red",
               });
            }
         },

         async doDeleteProposal(item) {
            let response = await this.$http({
               url: "/cca/removeproposal.php",
               headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
               },
               data: {
                  proposal_id: item.id,
                  proposer_role: item.proposer_role,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     this.loadProposal();
                  }
               }
            });
         },

         async loadProposal() {
            if (this.selectedyeargroup) {
               let response = await this.$http({
                  url: "/cca/getproposallist.php",
                  headers: {
                     "Content-Type": "application/x-www-form-urlencoded",
                  },
                  data: {
                     cca_year: this.$globalstore.appsettings.proposal_year,
                     cca_term: this.$globalstore.appsettings.proposal_term,
                     yeargroup: this.selectedyeargroup.yeargroup,
                     inc_asst: this.include_assisting,
                     userid: this.$globalstore.user.userid,
                     token: this.$globalstore.user.usertoken,
                  },
                  method: "POST",
               }).then((response) => {
                  if (response.data.autherror) {
                     this.$globalstore.user.tokenexpired = true;
                  } else {
                     if (response.data.error) {
                        this.ShowMessage({
                           title: "Error",
                           message: response.data.message,
                           color: "red",
                        });
                     } else {
                        this.$globalstore.proposal.page = null;
                        this.$globalstore.proposal.proposaldata = [];
                        this.proposaldata = response.data.proposaldata;
                     }
                  }
               });
            }
         },
      },

      mounted() {
         if (this.$globalstore && this.$globalstore.appready) {
            if (this.$globalstore.proposal.yeargroup) {
               this.selectedyeargroup = Object.assign({}, this.$globalstore.proposal.yeargroup);

               if (this.$globalstore.proposal.selectedproposalstatus) {
                  this.selectedproposalstatus = Object.assign(
                     {},
                     this.$globalstore.proposal.selectedproposalstatus
                  );
               }
               // if page number saved, then don't reload proposal data.
               if (this.$globalstore.proposal.page) {
                  this.proposaldata = this.$globalstore.proposal.proposaldata.slice();
                  this.pagination.page = this.$globalstore.proposal.page;
               } else {
                  this.$globalstore.proposal.proposaldata = [];
                  this.loadProposal();
               }
            }
         }
      },
   };
</script>
